import { USER_KEY } from '../../helpers/constants';
import { AuthenthicatedUserInfo, AuthState } from '../../interfaces';
import { AuthAction } from '../actions';
import { ActionType } from '../action_types';

const initialState: AuthState = {
  isAuthenticated: localStorage.getItem(USER_KEY) ? true : false,
  authUser: localStorage.getItem(USER_KEY) ? (JSON.parse(localStorage.getItem(USER_KEY)!) as AuthenthicatedUserInfo) : null,
};

const authReducer = (state = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case ActionType.SIGNIN:
      return { ...state, authUser: action.payload.user, isAuthenticated: true };

    case ActionType.SIGNOUT:
      return { ...state, authUser: null, isAuthenticated: false };

    case ActionType.COMPLETE_PROFILE:
      return { ...state, authUser: action.payload.user }

    default:
      return { ...state };
  }
};

export default authReducer;
